import { useContext, useEffect, useState } from 'react';
import { A03, A03Output } from '../../api/U003';
import { AppContext } from 'templates/AppContextProvider';

export function useGetAuditionsParticipated(): [A03Output, boolean, Error | null] {
  const [auditions, setAuditions] = useState<A03Output>({ auditions: [] });
  const [loading, setLoading] = useState(true);
  const [err, setError] = useState<Error | null>(null);
  const ctx = useContext(AppContext);

  const FetchAudtions = async (userId: string, lang: string, cancellation: AbortSignal) => {
    const json = await A03(userId, lang, cancellation);
    return json;
  };

  useEffect(() => {
    const controller = new AbortController();
    const cancellation = controller.signal;

    async function fetch() {
      if (!ctx.userId) return;
      try {
        setLoading(true);
        setError(null);
        const auditions = await FetchAudtions(ctx.userId, ctx.currentLang, cancellation);
        setAuditions(auditions);
      } catch (err) {
        if (err instanceof DOMException && err.message === 'signal is aborted without reason')
          return;
        if (err instanceof Error) {
          setError(err);
        } else {
          setError(new Error(`unknown error. ${err}`));
        }
      } finally {
        setLoading(false);
      }
    }

    fetch();
    return () => {
      controller.abort();
    };
  }, [ctx.userId, ctx.currentLang]);

  return [auditions, loading, err];
}
